import { render, staticRenderFns } from "./HeaderProduct.vue?vue&type=template&id=373a33b4&scoped=true&"
import script from "./HeaderProduct.vue?vue&type=script&lang=js&"
export * from "./HeaderProduct.vue?vue&type=script&lang=js&"
import style0 from "./HeaderProduct.vue?vue&type=style&index=0&id=373a33b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373a33b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
